"use client";

import Link from "next/link";
import { useActionState } from "react";
import { TurnstileWidget } from "../turnstile-widget";
import { register } from "./actions";

export function RegisterForm({ callbackUrl }: { callbackUrl?: string }) {
  const action = register.bind(null, callbackUrl ?? null);
  const [error, formAction, pending] = useActionState(action, undefined);
  const loginHref = callbackUrl
    ? `/login?callbackUrl=${encodeURIComponent(callbackUrl)}`
    : "/login";

  return (
    <form action={formAction} className="space-y-5">
      <div>
        <label htmlFor="email" className="mb-1.5 block text-sm font-bold text-zinc-700">
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          className="w-full rounded-xl border border-[#e0507a]/20 bg-white px-4 py-3 text-sm text-zinc-900 outline-none transition-colors placeholder:text-zinc-400 focus:border-[#e0507a] focus:ring-2 focus:ring-[#e0507a]/20"
        />
      </div>

      <div>
        <label htmlFor="password" className="mb-1.5 block text-sm font-bold text-zinc-700">
          Hasło
        </label>
        <input
          id="password"
          name="password"
          type="password"
          required
          minLength={8}
          autoComplete="new-password"
          className="w-full rounded-xl border border-[#e0507a]/20 bg-white px-4 py-3 text-sm text-zinc-900 outline-none transition-colors placeholder:text-zinc-400 focus:border-[#e0507a] focus:ring-2 focus:ring-[#e0507a]/20"
        />
        <p className="mt-1.5 text-xs text-zinc-500">Co najmniej 8 znaków.</p>
      </div>

      <TurnstileWidget />

      {error && (
        <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={pending}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#e8607a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#d4556e] disabled:pointer-events-none disabled:opacity-60"
      >
        {pending ? "Tworzenie konta…" : "Załóż konto"}
      </button>

      <p className="text-center text-sm text-zinc-600">
        Masz już konto?{" "}
        <Link href={loginHref} className="font-bold text-[#e0507a] hover:text-[#c9436a]">
          Zaloguj się
        </Link>
      </p>
    </form>
  );
}
